import { useQuery, useQueryClient } from "@tanstack/react-query";
import {
  fetchProfileAndWallet,
  type ProfileWalletBundle,
} from "../../services/profileWalletService";

export const profileWalletQueryKey = (userId: string | undefined) =>
  ["profile-wallet", userId ?? ""] as const;

export function useProfileWalletQuery(userId: string | undefined) {
  return useQuery<ProfileWalletBundle>({
    queryKey: profileWalletQueryKey(userId),
    queryFn: () => fetchProfileAndWallet(userId!),
    enabled: Boolean(userId),
  });
}

export function useInvalidateProfileWallet() {
  const qc = useQueryClient();
  return (userId: string | undefined) =>
    qc.invalidateQueries({ queryKey: profileWalletQueryKey(userId) });
}
